<app-student-module ModuleName="Communications" [Loading]="loading" [PrintOptions]="printOptions" [NewHidden]="false"
                    (New)="newContact()">
  <div class="container-fluid">
    <div class="py-1 row d-print-none" *ngFor="let c of contacts">
      <div class="col">
        {{ c.date | date: 'shortDate' }}
      </div>
      <div class="col">
        {{ c.type }}
      </div>
      <div class="col">
        {{ c.staff_id | staffId | async }}
      </div>
      <div class="col">
        <div class=" d-flex">
          <button class="ms-auto btn btn-outline-primary btn-sm" (click)="openContact(c)">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let c of contacts" class="d-none d-print-block" style="break-inside: avoid;">
    <hr />
    <div class="row">
      <div class="col-6 fw-bold">Date</div>
      <div class="col">{{ c.date | date: 'shortDate' }}</div>
    </div>
    <div class="row">
      <div class="col-6 fw-bold">Method</div>
      <div class="col">{{ c.type }}</div>
    </div>
    <div class="row">
      <div class="col-6 fw-bold">Assessment Shared</div>
      <div class="col">{{ c.assess_shared }}</div>
    </div>
    <div class="row">
      <div class="col-6 fw-bold">Information Shared</div>
      <div class="col">{{ c.info_shared }}</div>
    </div>
    <div class="row">
      <div class="col-6 fw-bold">Staff</div>
      <div class="col">{{ c.staff_id | staffId | async }}{{ c.staff_name }}</div>
    </div>
    <div class="row">
      <div class="col-6 fw-bold">Outcome</div>
      <div class="col">{{ c.outcome }}</div>
    </div>
  </div>
</app-student-module>
